module.exports = __webpack_public_path__ + "static/media/waterproof-sofa.6e2d44c8.png";